import SelectorEngine from '../../utils/dom/selector-engine';
import EventHandler from '../../utils/dom/event-handler';
import FormComponent from '../FormComponent';
import SearchInputField from '../SearchInputField';
import { InputTypes } from '../../utils/validateFormElement';

const CLICK_EVENT = 'click';

const HIDDEN_CLASS = 'u-hidden';

class MentorFinder extends FormComponent {
	constructor(element, config) {
		super(element, config);
	}
	markup(value, rowData, titleMarkup) {
		return `
            <div class="lta-mentor-finder u-mb-5">
				<div class="lta-mentor-finder-title u-hidden">${titleMarkup}</div>
                <div class="lta-mentor-finder--search-input-wrapper">
					<div class="lta-mentor-finder--search-input u-mb-2"></div>
				</div>
				<div class="lta-mentor-finder--search-result u-hidden"></div>
            </div>
        `;
	}
	afterRender() {
		this.mentorFinderElement = SelectorEngine.findOne('.lta-mentor-finder', this.containerEl);
		this.mentorFinderTitle = SelectorEngine.findOne('.lta-mentor-finder-title', this.mentorFinderElement);
		this.mentorFinderSearchInputWrapper = SelectorEngine.findOne(
			'.lta-mentor-finder--search-input-wrapper',
			this.mentorFinderElement
		);
		this.mentorFinderSearchInput = SelectorEngine.findOne(
			'.lta-mentor-finder--search-input',
			this.mentorFinderSearchInputWrapper
		);
		this.mentorFinderSearchResult = SelectorEngine.findOne(
			'.lta-mentor-finder--search-result',
			this.mentorFinderElement
		);

		this.initSearchInputField();
	}
	initSearchInputField() {
		this.searchInputTextField = new SearchInputField(this.mentorFinderSearchInput, {
			data: this.data
		});
		this.searchInputTextField.dataMapping = (item) => {
			return {
				firstLineText: item.name,
				dataKey: this.data.dataKey,
				dataValue: item.name
			};
		};
		this.searchInputTextField.filterDataMapping = (item, event) => {
			return item.name === event[this.data.dataKey];
		};
		this.searchInputTextField.searchInputMappingChange();
		this.searchInputTextField.onChange((event) => {
			this.loadParkResult(event.value, true);
		});
		this.setupValidateObject();
		if (this.data?.value) {
			this.loadParkResult(this.data?.value, false);
		}
	}
	loadParkResult(resultDetails, isSetupValueObject) {
		if (isSetupValueObject) {
			this.setupValueObject(resultDetails, 'Complete');
		}
		if (!resultDetails?.name) {
			return;
		}
		this.mentorFinderSearchInputWrapper.classList.add(HIDDEN_CLASS);
		this.mentorFinderTitle.classList.remove(HIDDEN_CLASS);
		this.mentorFinderSearchResult.classList.remove(HIDDEN_CLASS);
		this.mentorFinderSearchResult.insertAdjacentHTML('beforeend', this.renderAutoSuggestResult(resultDetails));
		this.afterAutoSuggestResultRender();
	}
	setupValueObject(value, obBoardingStatus) {
		this.value = {
			...this.data,
			value: value
				? {
						...value,
						onboardingStatus: obBoardingStatus
				  }
				: undefined
		};
		if (this.value) {
			this.dependentQuestion = this.value.dependentQuestion;
		}
	}
	afterAutoSuggestResultRender() {
		const suggestionAutoSuggestResult = SelectorEngine.findOne(
			'.lta-autosuggest-input-result',
			this.mentorFinderSearchResult
		);
		const searchAgainButton = SelectorEngine.findOne('.lta-mentor-search--again', suggestionAutoSuggestResult);

		EventHandler.on(searchAgainButton, CLICK_EVENT, () => {
			this.value = undefined;
			suggestionAutoSuggestResult.remove();
			this.searchInputTextField.remove();
			this.initSearchInputField();
			this.mentorFinderSearchInputWrapper.classList.remove(HIDDEN_CLASS);
			this.mentorFinderTitle.classList.add(HIDDEN_CLASS);
			//this.parkFinderSearchForm.classList.add(HIDDEN_CLASS);
			this.mentorFinderSearchResult.classList.add(HIDDEN_CLASS);
		});
	}
	renderAutoSuggestResult(mentor) {
		return `<div class="lta-autosuggest-input-result u-mb-4">
					<div class="u-mb-1">
						${this.renderInstructionLabel(this.data.instructionText)}
					</div>
					${!this.data?.resultTitleNotVisible ? `<div class="lta-text-input__label">Your ${this.data.venueType}</div>` : ''}
					<div class="u-px-3 u-py-2 u-bg-background-blue u-rounded">
						<div class="lta-autosuggest-input-result_park-name u-h6 u-mb-2">${mentor.name}</div>
						<button type="button" class="lta-btn lta-btn--xs lta-btn--petite lta-btn--icon lta-btn--icon-before lta-mentor-search--again">
							<svg class="lta-icon js-lta-text-input--btn-icon u-mr-1" width="1.5em" height="1.5em" fill="currentColor" alt="search" aria-hidden="true">
								<use xlink:href="/static/images/icons/lta-icons.svg#close"></use>
							</svg>Remove ${this.data.venueType}
						</button>
					<div>
				</div>`;
	}
	renderInstructionLabel(instructionLabel) {
		return instructionLabel
			? `<label class="lta-text-input__label u-text-grey-lta">
			<span class="lta-text-input__label-instruction u-caption1">${instructionLabel}</span>
		</label>`
			: '';
	}
	setupValidateObject() {
		this.formElementData = {
			element: this.searchInputFieldContainerElement,
			formElement: this.searchInputFieldElement,
			errorMessage: this.data.errorMessage,
			inputType: InputTypes.SELECTOR_INPUT,
			hasIcon: false
		};
	}
	validate() {
		this.searchInputTextField.validate(true);
	}
}
export default MentorFinder;
